import fpSuteren from "./img-15.jpg";
import fpPrizemi from "./img-16.jpg";
import fpPatro from "./img-17.jpg";

const FLOOR_PLAN_KEYS = new Set([
  "./img-15.jpg",
  "./img-16.jpg",
  "./img-17.jpg",
]);

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

const sorted = Object.entries(photoModules)
  .filter(([key]) => !FLOOR_PLAN_KEYS.has(key))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const branikPozemekImages: string[] = sorted;

export const branikPozemekFloorPlans: { image: string; label: string }[] = [
  { image: fpSuteren, label: "Suterén" },
  { image: fpPrizemi, label: "Přízemí" },
  { image: fpPatro, label: "Patro" },
];
